import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dangerAll",
  "use": "dangerAll-usage",
  "viewBox": "0 0 17.59 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.59 20\" id=\"dangerAll\"><title>dangerAll</title><path d=\"M8.29.14L.51 4.63a1 1 0 0 0-.51.88v9a1 1 0 0 0 .51.88l7.78 4.49a1 1 0 0 0 1 0l7.78-4.49a1 1 0 0 0 .51-.88v-9a1 1 0 0 0-.51-.88L9.31.14a1 1 0 0 0-1.02 0zM14.46 10a.86.86 0 0 1-.86.86H3.99a.86.86 0 0 1-.85-.86.86.86 0 0 1 .86-.86h9.61a.86.86 0 0 1 .86.86z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dangerAll.svg
// module id = rs4T
// module chunks = 6